/**
 * Weather contracts — the normalized shape every weather vendor is translated
 * into, shared by the backend adapters, the REST surface and both frontends.
 *
 * Units are fixed and non-negotiable across every adapter: Celsius, km/h,
 * millimetres. An adapter that cannot honor them is a broken adapter, not a
 * reason to widen these types.
 *
 * The consumer port itself (`WeatherProvider`, `WeatherProviderDescriptor`,
 * `WeatherQuery`) lives backend-side in
 * `external-integrations/weather/types.ts`, mirroring how `EmailProvider` is
 * split from `EmailServiceHealthCheck` here.
 */
export var WeatherProviderId;
(function (WeatherProviderId) {
    WeatherProviderId["OPEN_METEO"] = "open_meteo";
    WeatherProviderId["GOOGLE_WEATHER"] = "google_weather";
    WeatherProviderId["OPENWEATHERMAP"] = "openweathermap";
})(WeatherProviderId || (WeatherProviderId = {}));
export var WeatherCondition;
(function (WeatherCondition) {
    WeatherCondition["CLEAR"] = "CLEAR";
    WeatherCondition["PARTLY_CLOUDY"] = "PARTLY_CLOUDY";
    WeatherCondition["CLOUDY"] = "CLOUDY";
    WeatherCondition["FOG"] = "FOG";
    WeatherCondition["DRIZZLE"] = "DRIZZLE";
    WeatherCondition["RAIN"] = "RAIN";
    WeatherCondition["HEAVY_RAIN"] = "HEAVY_RAIN";
    WeatherCondition["SNOW"] = "SNOW";
    WeatherCondition["THUNDERSTORM"] = "THUNDERSTORM";
    WeatherCondition["UNKNOWN"] = "UNKNOWN";
})(WeatherCondition || (WeatherCondition = {}));
//# sourceMappingURL=Weather.js.map